import BaseApi from './BaseApi';

import { FilterDateParams } from 'models';
import { DownloadTaxStatementProps, StatementProps } from 'models/api';

class TaxStatementApi extends BaseApi {
	constructor() {
		super('/investor/tax-statement');
	}

	getAll({ params }: { params: FilterDateParams }) {
		return this.httpClient.get({ config: { params }, conditions: { auth: true } });
	}

	generate(body: StatementProps) {
		return this.httpClient.post({ body, conditions: { auth: true } });
	}

	download({ id }: DownloadTaxStatementProps) {
		return this.httpClient.get({
			url: `/${id}`,
			config: {
				responseType: 'blob',
			},
			conditions: { auth: true },
		});
	}
}

export const TaxStatementService = new TaxStatementApi();
